import { RouteObject, Outlet, Navigate } from 'react-router-dom';
import type { RouterProps } from 'contracts/Router';
import { EmailLogListPage } from 'pages/AlertEmailLogs';
import { EmailLogShow } from 'pages/AlertEmailLogs/EmailLogShow';

const alertEmailLogs = ({
  location,
  userBelongsToAnyOf,
}: RouterProps): RouteObject => ({
  path: 'configuracoes/historico-alertas',
  element: userBelongsToAnyOf('admin') ? (
    <Outlet />
  ) : (
    <Navigate to="/" state={{ from: location }} />
  ),
  children: [
    {
      path: '',
      element: <EmailLogListPage />,
    },
    {
      path: ':id',
      element: <EmailLogShow />,
    },
  ],
});

export default alertEmailLogs;